import { computed } from 'vue';
import { Router } from 'vue-router';

import { useFeatureFlags } from 'SharedDir/common/composables/useFeatureFlags';
import { usePermissions } from 'SharedDir/common/composables/usePermissions';
import { FeatureFlagName } from 'SharedDir/declarations/system/region-customization';

export const PORTAL_CERTIFICATES_ROUTE = 'profile-certificates';
export const ADMIN_CERTIFICATES_ROUTE = 'account-certificates';

/**
 * Портал и админка регистрируют раздел под разными именами роута.
 * Общий диалог подписи берёт то имя, которое есть в текущем приложении.
 * Флаг выключен — роута нет, фраза остаётся обычным текстом.
 */
export function resolveMyCertificatesRouteName(router: Router): string | null {
  if (router.hasRoute(PORTAL_CERTIFICATES_ROUTE)) {
    return PORTAL_CERTIFICATES_ROUTE;
  }
  if (router.hasRoute(ADMIN_CERTIFICATES_ROUTE)) {
    return ADMIN_CERTIFICATES_ROUTE;
  }
  return null;
}

export function useMyCertificatesAccess() {
  const { getFeatureFlag } = useFeatureFlags();
  const { canAny, permissionSet } = usePermissions();

  const showMyCertificates = computed(
    () =>
      getFeatureFlag(FeatureFlagName.HasMyCertificates).value &&
      canAny(permissionSet.userCertificate.list, permissionSet.userCertificate.listAll)
  );

  return { showMyCertificates };
}
